<template>
  <div class="main-container">
    <h1>{{$t('documentation.title')}}</h1>
  </div>
</template>

<script lang="ts">
import { Component,Vue } from 'vue-property-decorator';


@Component({
})
export default class Documentation extends Vue {
}
</script>

<style scoped="scss">
</style>
